import { useAtom } from 'jotai/index';
import { languageAtom } from '../atoms/globalAtoms';

const useTranslations = () => {
  const [lang, setLang] = useAtom(languageAtom);

  function t(dictObj, ...params) {
    return dictObj[lang](...params);
  }

  return { lang, setLang, t };
};

export default useTranslations;
